"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const contracts = {
    MINTER: 'KT1QXaDLEmmU6b5TDUAJ1eSktHfpRXoqyfZV',
    OVEN_PROXY: 'KT1JzikXutuoWC6okZK19HEfj2aJg4ou5HCu',
    OVEN_FACTORY: 'KT1JXGCvG2pHLch6tGSwvhfAf9RcuTMphwGV',
    TOKEN: 'KT1PRFhWsUTpZPdFfBgLVwVEtUYrv33VDTRw',
    OVEN_REGISTRY: 'KT1ErAKodz6b7vfFoimCimVUFh9NHKPfdU9Y',
    DEVELOPER_FUND: 'KT1FHE7qiuZDJejQrK3qikbzjj9r8X7FqGkg',
    STABILITY_FUND: 'KT1QPSHsRAL6Z857kmkFVFvf6LjiMbVbX6vm',
    ORACLE: 'KT1CLJSZF4G8T22jYKmLf8WUG6GH9HCPD31Q',
    HARBINGER_NORMALIZER: 'KT18xT2hAWdyihbZ5Hw1bYSszGE2NwHpSxUF',
    LIQUIDITY_POOL: 'KT1N2rHTrsnKgekiHsmYuThSZ7endgNhVrHr',
    DEXES: {
        QUIPUSWAP: {
            POOL: 'KT1U95NH2rWxiCQogesoaeMetSsxMvEUm3iJ',
            FA1_2_FACTORY: 'KT1XFrtWubajV85iym1kwLLXZhJHMZpm9Twu',
            FA2_FACTORY: null,
        },
        PLENTY: { POOL: null, PLENTY_QUIPUSWAP_POOL: null, PLENTY_TOKEN: null },
    },
    KOLIBRI_BAKER: null,
    GOVERNOR: 'KT1SJRLoAtrpWNLJpb6L9XyXjSRuh9GpApCD',
    PAUSE_GUARDIAN: 'KT1K73GhQq4DynmFHJq2LSQBNhuX6r4CMU85',
    BREAK_GLASS_MULTISIG: 'KT1TrvLMfqhFyyEgPyCz5GAuxuXFrWGoi32T',
    FUND_ADMIN: null,
    DAO: 'KT1UkbsdVU29K5N2QpvKhp6KXChJY5RmNXhj',
    DAO_TOKEN: 'KT1R2C4vZwMGyizAKLp9QiZ3kmhZKpszqezz',
    DAO_COMMUNITY_FUND: 'KT1LHbDjwPmVnPRY9iWr5DYABTPQgEja7Vuc',
    FARMS: {
        KUSD: {
            farm: 'KT1TUU9LWjdcXKcjfKoJ5ExMWyLxyx5aBfFD',
            reserve: 'KT1BxUVHcKUouX8A2fxUCUsjELcq8tLoTZas',
        },
        QLKUSD: {
            farm: 'KT1V7mpLshHuAwea8hwYKVThKwqReEjhXEAL',
            reserve: 'KT19E59RZwx24Cp6C6YNdUVcAiPiQnrwMZ7o',
        },
        KUSD_LP: {
            farm: 'KT1TUU9LWjdcXKcjfKoJ5ExMWyLxyx5aBfFD',
            reserve: 'KT1BxUVHcKUouX8A2fxUCUsjELcq8tLoTZas',
        },
    },
    VESTING_CONTRACTS: {
        tz1VSUr8wwNhLAzempoch5d6hLRiTh8Cjcjb: 'KT1KjLNnzn4VthbYWV4zYVZaRfJBNCM39u9L',
        tz1QM9J63wfTrGW7HLotr7Kshy8q8LhdorJe: 'KT1QadNbZmKEo3P52JKMhuFSAXTEPPF67joq',
        tz1YvwHP7TDbAMWf2sFZ5AzjRPe4GyA7Fc46: 'KT19ybXQvtXB7h5ZdtUamJVD9RgdopnSqD2S',
    },
    BREAK_GLASS_CONTRACTS: {
        MINTER: 'KT1Qi1byYJJY8qgaZ9LFravXTQ8WMAksLyah',
        OVEN_PROXY: 'KT1VSBDcaD8HF9syVsKQhF9EBtD8WxMUNTGW',
        OVEN_FACTORY: 'KT1AZSkWi3A6A99GfYZgGmojrE7xmbKMu762',
        TOKEN: 'KT1UkhV95C9RunnTXr2TVPe97YBbrXQzMBeE',
        OVEN_REGISTRY: 'KT1NuGiDA9EYMPxHcyPX9b73ofUqM7qN1Hix',
        DEVELOPER_FUND: 'KT1FZKgkpZCuuVgtwihryUeN8BC3du36eM2i',
        STABILITY_FUND: 'KT1Ky5YVCjPtFo1gQ5oKZ5KqvxVxQPSbSWZK',
        ORACLE: 'KT1MXw8DmMSDjVz2HX1xVEznQGDaVjNS39bu',
        LIQUIDITY_POOL: 'KT1RahhVumTz9gskrdoRUthvqdn2ajS5HyFk',
        DAO_COMMUNITY_FUND: 'KT1DfZhyFqaa1EXAxv3A5TrY7QRQurtPaxcL',
        VESTING_VAULTS: {
            tz1VSUr8wwNhLAzempoch5d6hLRiTh8Cjcjb: 'KT193RkaYfHLoH3KbNnqY5mFnBnjLKHW72Uu',
            tz1QM9J63wfTrGW7HLotr7Kshy8q8LhdorJe: 'KT19DCvsh5hgTJHxgYnyhq4sFKSiDTHKYpha',
            tz1YvwHP7TDbAMWf2sFZ5AzjRPe4GyA7Fc46: 'KT1W9zHjLEMKftwThQDRzWDzmtV2s96yRrjE',
        },
    },
};
exports.default = contracts;
//# sourceMappingURL=sandbox.js.map